import Swiper from "swiper/bundle";
import "swiper/css/bundle";

function initCardsSlider() {
  const swiper = new Swiper(".cards-slider", {
    slidesPerView: 1,
    spaceBetween: 20,
    centeredSlides: true,
    loop: true,
    navigation: {
      nextEl: ".cards-slider-next",
      prevEl: ".cards-slider-prev",
    },
    pagination: {
      el: ".cards-slider-pagination",
      type: "bullets",
      clickable: true,
    },
    breakpoints: {
      768: {
        slidesPerView: 1.5,
      },
      1250: {
        slidesPerView: 1.9,
      },
      1920: {
        slidesPerView: 2.8,
      },
    },
  });
}

export { initCardsSlider };
